import React from "react";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Button from "@material-ui/core/Button";
import ListItem from "@material-ui/core/ListItem";
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import CancelSuccess from "./CancelSuccess";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: "center",
    '& .MuiGrid-root': {
      margin: "24px 0"
    },
    '& .MuiInput-root': {
      alignItems: "baseline",
      padding: 0
    },
    '& .MuiInputBase-multiline': {
      alignItems: "baseline",
      minHeight: "10rem",
      height: "auto"
    },
    '& .MuiFormControlLabel-root': {
      margin: "0 15px 0 -11px"
    },
    '& .MuiFormControl-root': {
      margin: "0",
      width: "100%"
    },
    '& .MuiList-padding': {
      padding: 0
    },
    '& .MuiListItem-gutters': {
      padding: 0
    },
    '& .MuiTypography-root': {
      overflowWrap: "unset"
    },
  },
  wrapper: {
    margin: theme.spacing(1, 0),
    position: "relative",
    '& .MuiButtonBase-root': {
      lineHeight: 1
    },
  },
  formControl: {
    margin: theme.spacing(2),
  },
  buttonProgress: {
    color: "primary",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
}));

const divSubmitStyle = makeStyles(() => ({
  buttonStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    position: "sticky",
    background: "#FFFFFF",
    top: 1,
    bottom: "-30px",
    zIndex: 10,
  },
  dashboardButtonStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    position: "sticky",
    background: "#FFFFFF",
    top: 1,
    bottom: "-30px",
    zIndex: 10,
    margin: "30px 0"
  },
}));

export default function CancelForm(props) {
  const {
    error,
    loading,
    checkboxValue,
    cancelSuccess,
    buttonDisabled,
    textInputValue,
    otherReasonInputValue,
    handleExit,
    handleCancel,
    handleInputChange,
    handleSuccessCancel,
    handleCheckboxChange,
    handleOtherInputChange
  } = props;

  const classes = useStyles();
  const buttonStyle = divSubmitStyle();

  const cancelReasons = [
    "I will reschedule in the future",
    "I'm no longer interested",
    "I have a question, please contact me",
    "Other"
  ];
  const otherCancelReason = cancelReasons[cancelReasons.length - 1].toLocaleLowerCase();

  return (
    (!cancelSuccess ?
      <React.Fragment>
        <Typography style={{
          paddingTop: "30px",
          fontSize: "35px",
          fontWeight: "bold"
        }} gutterBottom>
          Cancel your appointment
        </Typography>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className={classes.root}
        >
          <FormControl component="fieldset" className={classes.formControl}>
            <FormLabel component="legend">Reasons for cancellation:</FormLabel>
            <FormGroup>
              {cancelReasons.map((reason, index) => {
                if (reason.toLocaleLowerCase() === otherCancelReason) {
                  return <List key={index}>
                    <ListItem>
                      <FormControlLabel
                        label="Other "
                        control={
                          <Checkbox
                            id="other"
                            checked={checkboxValue?.toLowerCase() === reason.toLowerCase()}
                            onChange={handleCheckboxChange}
                            name={reason}
                            checkedIcon={<CheckBoxOutlinedIcon />}
                          />
                        }
                      />
                      <TextField
                        id={'otherCancelAppointmentReason'}
                        InputProps={{ disableUnderline: true }}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleOtherInputChange}
                        value={otherReasonInputValue}
                        style={{ height: "2rem" }}
                        label=""
                        fullWidth
                        size="small"
                        placeholder=""
                        disabled={!(checkboxValue?.toLowerCase() === otherCancelReason)}
                      />
                    </ListItem>
                  </List>
                } else {
                  return <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        id={reason}
                        checked={checkboxValue?.toLowerCase() === reason.toLowerCase()}
                        onChange={handleCheckboxChange}
                        name={reason}
                        checkedIcon={<CheckBoxOutlinedIcon />}
                      />
                    }
                    label={reason}
                  />
                }
              })}
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid container className={classes.root}>
          <TextField
            id={'cancelAppointmentReason'}
            label="We're sorry to see you go. Please leave a comment and let us know how we could improve this service"
            InputProps={{ disableUnderline: true }}
            InputLabelProps={{ shrink: true }}
            onChange={handleInputChange}
            value={textInputValue}
            placeholder="Please leave a comment and let us know how we could improve this service"
            helperText={error?.error ? error?.errorMessage : ''}
            error={error?.error}
            rowsMax={10}
            fullWidth
            multiline
          />
        </Grid>
        <Typography
          gutterBottom
          style={{
            margin: "20px 0 10px 0",
            fontSize: "12px"
          }}>
          <strong>Note:</strong> If there was a fee associated with your appointment a full refund will be processed within 7 business days and returned to the original form of payment.
        </Typography>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className={buttonStyle.buttonStyle}
        >
          <div className={classes.wrapper}>
            <Button
              onClick={handleExit}
              variant="contained"
              color="secondary"
              role="button"
            >
              Exit
            </Button>
          </div>
          <div className={classes.wrapper}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              role="button"
              onClick={handleCancel}
              disabled={buttonDisabled || loading}
            >
              Cancel Appointment
            </Button>
            {loading && <CircularProgress
              size={24}
              className={classes.buttonProgress}
            />}
          </div>
        </Grid>
      </React.Fragment>
      : <CancelSuccess
        handleSuccessCancel={handleSuccessCancel}
      />
    )
  );
};
